import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { AlertTriangle, ShieldCheck, Activity, Zap } from "lucide-react";
import styles from "./socDashboard.module.scss";

const stats = [
  {
    title: "Active Alerts",
    value: "23",
    sub: "5 critical, 8 high",
    icon: <AlertTriangle size={20} color="#ef4444" />,
  },
  {
    title: "Threats Blocked",
    value: "147",
    sub: "+12% vs yesterday",
    positive: true,
    icon: <ShieldCheck size={20} color="#0CA6F2" />,
  },
  {
    title: "MTTR",
    value: "8.2m",
    sub: "Mean time to resolve",
    icon: <Activity size={20} color="#10b981" />,
  },
  {
    title: "Auto-Resolved",
    value: "89%",
    sub: "AI-driven response",
    icon: <Zap size={20} color="#a855f7" />,
  },
];

export const SocStats = () => {
  return (
    <Box className={styles.statsGrid}>
      {stats.map((stat) => (
        <Card key={stat.title} className={styles.card}>
          <Box className={styles.cardHeader}>
            {stat.icon}
            <span>{stat.title}</span>
          </Box>
          <Typography className={styles.cardValue} fontWeight={700}>
            {stat.value}
          </Typography>
          <Typography
            className={stat.positive ? styles.positive : styles.cardSub}
          >
            {stat.sub}
          </Typography>
        </Card>
      ))}
    </Box>
  );
};

export default SocStats;
